import React from 'react';

const Input = ({
  label,
  name,
  type = 'text',
  elementType = 'input', // input | textarea | select
  options = [],
  required = false,
  value = '',
  onChange,
  placeholder
}) => {
  return (
    <div className="mb-3">
      <label className="form-label">
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>

      {elementType === 'select' ? (
        <select
          className="form-select"
          name={name}
          value={value}
          onChange={onChange}
          required={required}
        >
          <option value="">Select {label}</option>

          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      ) : elementType === 'textarea' ? (
        <textarea
          className="form-control"
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder || `Enter ${label}`}
          required={required}
          rows={4}
        />
      ) : (
        <input
          type={type}
          className="form-control"
          name={name}
          value={type !== 'file' ? value : undefined}
          onChange={onChange}
          placeholder={placeholder || `Enter ${label}`}
          required={required}
        />
      )}
    </div>
  );
};

export default Input;

// below html example 

 {/*   
 <Input
   label="Gender"
   name="gender"
   elementType="select"
   value={form.gender}
   onChange={handleChange}
   options={[
     { value: 'M', label: 'Male' },
     { value: 'F', label: 'Female' },
     { value: 'O', label: 'Other' }
   ]}
 />
 
// */}
// {/* Text */}
// <Input
//   label="Name"
//   name="name"
//   type="text"
//   value={form.name}
//   onChange={handleChange}
// />

// {/* Email */}
// <Input
//   label="Email"
//   name="email"
//   type="email"
//   value={form.email}
//   onChange={handleChange}
// />

// {/* Password */}
// <Input
//   label="Password"
//   name="password"
//   type="password"
//   value={form.password}
//   onChange={handleChange}
// />

// {/* Number */}
// <Input
//   label="Age"
//   name="age"
//   type="number"
//   value={form.age}
//   onChange={handleChange}
// />

// {/* Tel */}
// <Input
//   label="Phone"
//   name="phone"
//   type="tel"
//   value={form.phone}
//   onChange={handleChange}
// />

// {/* URL */}
// <Input
//   label="Website"
//   name="website"
//   type="url"
//   value={form.website}
//   onChange={handleChange}
// />

// {/* Search */}
// <Input
//   label="Search"
//   name="search"
//   type="search"
//   value={form.search}
//   onChange={handleChange}
// />

// {/* Date */}
// <Input
//   label="Date of Birth"
//   name="dob"
//   type="date"
//   value={form.dob}
//   onChange={handleChange}
// />

// {/* Time */}
// <Input
//   label="Time"
//   name="time"
//   type="time"
//   value={form.time}
//   onChange={handleChange}
// />

// {/* Datetime Local */}
// <Input
//   label="Meeting Date"
//   name="meetingDate"
//   type="datetime-local"
//   value={form.meetingDate}
//   onChange={handleChange}
// />

// {/* Month */}
// <Input
//   label="Month"
//   name="month"
//   type="month"
//   value={form.month}
//   onChange={handleChange}
// />

// {/* Week */}
// <Input
//   label="Week"
//   name="week"
//   type="week"
//   value={form.week}
//   onChange={handleChange}
// />

// {/* Color */}
// <Input
//   label="Favorite Color"
//   name="color"
//   type="color"
//   value={form.color}
//   onChange={handleChange}
// />

// {/* Range */}
// <Input
//   label="Volume"
//   name="volume"
//   type="range"
//   value={form.volume}
//   onChange={handleChange}
// />

// {/* Hidden */}
// <Input
//   label="Hidden Field"
//   name="token"
//   type="hidden"
//   value={form.token}
//   onChange={handleChange}
// />

// {/* File */}
// <Input
//   label="Profile Photo"
//   name="photo"
//   type="file"
//   onChange={handleChange}
// />

// {/* Textarea */}
// <Input
//   label="Description"
//   name="description"
//   elementType="textarea"
//   value={form.description}
//   onChange={handleChange}
// />